import React from "react";
import ReactDOM from "react-dom";
import { ComponentType } from "react";
import "../styles/main.scss";
import { createRoot } from "react-dom/client";

const observer = new MutationObserver((mutationsList, observer) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList" || mutation.type === "attributes") {
      // renderComponents();
    }
  }
});

const COMPONENT_MAP: Record<string, ComponentType<any>> = {
  Testimonial: React.lazy(
    () => import("../components/Testimonial/Testimonial")
  ),
  Header: React.lazy(() => import("../components/Header/Header")),
  Footer: React.lazy(() => import("../components/Footer/Footer")),
  Navigation: React.lazy(() => import("../components/Navigation/Navigation")),
  Texteaccordeon: React.lazy(
    () => import("../components/Texteaccordeon/Texteaccordeon")
  ),
  Odometer: React.lazy(() => import("../components/Odometer/Odometer")),
  Parallax: React.lazy(() => import("../components/Parallax/Parallax")),
  Titre: React.lazy(() => import("../components/Titre/Titre")),
  Moteur: React.lazy(() => import("../components/Moteur/Moteur")),
  Textedouble: React.lazy(
    () => import("../components/Textedouble/Textedouble")
  ),
  Contenumodulable: React.lazy(() => import("../components/Contenumodulable/Contenumodulable")),
  Carteetude: React.lazy(() => import("../components/Carteetude/Carteetude")),
  Accordeonblock: React.lazy(() => import("../components/Accordeonblock/Accordeonblock")),
  Pageheader: React.lazy(() => import("../components/Pageheader/Pageheader")),
  Pagefooter: React.lazy(() => import("../components/Pagefooter/Pagefooter")),
  Videoblock: React.lazy(() => import("../components/Videoblock/Videoblock")),
  Cookies: React.lazy(() => import("../components/Cookies/Cookies")),
  Cartefrance: React.lazy(() => import("../components/Cartefrance/Cartefrance")),
  Trombinoscope: React.lazy(() => import("../components/Trombinoscope/Trombinoscope")),
  Carousel: React.lazy(() => import("../components/Carousel/Carousel")),
  Page404: React.lazy(() => import("../components/Page404/Page404")),
};

function lazyLoadComponent(componentName: string) {
  return React.lazy(() =>
    import(`../components/${componentName}/${componentName}`)
  );
}

function renderComponents() {
  const elements = document.querySelectorAll(".react-component");

  elements.forEach((el) => {
    const currentIdentifier = generateComponentIdentifier(el);
    const previousIdentifier = el.getAttribute("data-previous-identifier");

    if (currentIdentifier === previousIdentifier) {
      return; // Skip re-rendering if the component hasn't changed
    }

    el.setAttribute("data-previous-identifier", currentIdentifier); // Store the identifier for next time

    const componentName = el.getAttribute("data-component");
    const propsString = el.getAttribute("data-props");

    if (componentName && propsString) {
      const Component: React.ComponentType<any> = COMPONENT_MAP[componentName];
      // const Component = lazyLoadComponent(componentName);

      const root = createRoot(el);
      const props = JSON.parse(propsString);
      root.render(<Component {...props} />);
    }
  });
}

let previousComponentsState = "";

function generateComponentIdentifier(el: Element): string {
  return el != null
    ? (el?.getAttribute("data-component") ?? "") +
    (el?.getAttribute("data-props") ?? "")
    : "";
}

function pollForChanges() {
  const currentComponentsState = Array.from(
    document.querySelectorAll(".react-component")
  )
    .map(generateComponentIdentifier)
    .join("");

  if (previousComponentsState !== currentComponentsState) {
    renderComponents();
    previousComponentsState = currentComponentsState;
  }
}

let isComponentsRendered = false;

function pollForComponentRender() {
  const editor = document.querySelector(".edit-post-visual-editor");
  if (editor && editor.querySelector(".react-component")) {
    renderComponents();
    isComponentsRendered = true;
  }
}

// anchor links should scroll smoothly
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (this: HTMLAnchorElement, e) {
    e.preventDefault();
    const targetElement = document.querySelector(this.getAttribute('href')!);
    targetElement!.scrollIntoView({
      behavior: 'smooth'
    });
  });
});


// Call the function to render components
window.addEventListener("load", () => {
  if (document.querySelector(".edit-post-visual-editor, .is-root-container")) {
    const intervalId = setInterval(() => {
      pollForComponentRender();
      if (isComponentsRendered) {
        clearInterval(intervalId); // Stop polling when components are rendered
        startPolling(); // Start the original polling for changes
      }
    }, 500); // Check every 0.5 seconds
  } else {
    renderComponents();
    startPolling();
  }


});



function startPolling() {
  setInterval(pollForChanges, 500); // Check every 0.5 seconds
}